import React from 'react';
import SideBar from '../../components/modules/left_sidebar';
import NavBar from '../../components/common/navbar';
import DashboardPermission from '../../components/Groups/dashboard_permission';

const Administration = false;
class AdminDashboardPermissions extends React.Component {
  constructor(props){
    super(props);
    this.state={
      groupName:"",
    }
  }

  componentDidMount() {
    const groupName = this.props.match.params.name;
    this.setState({
      groupName,
    })
}
  render() {
    console.log('opopop', this.props);
    if (!this.props.location.state) {
      this.props.history.go(-1);
    }
    const topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu;
    return (
      <div className="dashboard">
        <NavBar topBarMenuOption={topBarMenu} 
          moduleName="Administration"/>
        <SideBar Administration={Administration} />
        <DashboardPermission
          groupName={this.state.groupName || 'Permissão de grupo'}
        />
      </div>
    );
  }
}

export default AdminDashboardPermissions;
